"use strict";
var vec2 = require('gl-matrix/src/gl-matrix/vec2');
/**
 * Encapsulates a 2D vector. Allows chaining methods by returning a reference to itself
 * @author badlogicgames@gmail.com
 */
var Vector2 = (function () {
    /**
     * Constructs a vector from the given vector
     * @param v The vector
     */
    function Vector2(data) {
        this.data = data || vec2.create();
    }
    Object.defineProperty(Vector2.prototype, "x", {
        get: function () {
            return this.data[0];
        },
        set: function (val) {
            this.data[0] = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Vector2.prototype, "y", {
        get: function () {
            return this.data[1];
        },
        set: function (val) {
            this.data[1] = val;
        },
        enumerable: true,
        configurable: true
    });
    Vector2.prototype.clone = function () {
        return new Vector2(vec2.clone(this.data));
    };
    Vector2.prototype.len = function () {
        return vec2.len(this.data);
    };
    Vector2.prototype.sqrLen = function () {
        return vec2.sqrLen(this.data);
    };
    Vector2.prototype.copy = function (v) {
        vec2.copy(this.data, v.data);
        return this;
    };
    /**
     * Sets the components of this vector
     * @param x The x-component
     * @param y The y-component
     * @return This vector for chaining
     */
    Vector2.prototype.set = function (x, y) {
        vec2.set(this.data, x, y);
        return this;
    };
    Vector2.prototype.sub = function (v) {
        vec2.sub(this.data, this.data, v.data);
        return this;
    };
    Vector2.prototype.nor = function () {
        vec2.normalize(this.data, this.data);
        return this;
    };
    Vector2.prototype.add = function (v) {
        vec2.add(this.data, this.data, v.data);
        return this;
    };
    Vector2.prototype.dot = function (v) {
        return vec2.dot(this.data, v.data);
    };
    Vector2.prototype.scale = function (scalar) {
        vec2.scale(this.data, this.data, scalar);
        return this;
    };
    Vector2.prototype.scaleAndAdd = function (vec, scalar) {
        vec2.scaleAndAdd(this.data, this.data, vec.data, scalar);
        return this;
    };
    Vector2.prototype.dst = function (v) {
        return vec2.distance(this.data, v.data);
    };
    Vector2.prototype.dst2 = function (v) {
        return vec2.squaredDistance(this.data, v.data);
    };
    Vector2.prototype.limit = function (limit) {
        return this.limit2(limit * limit);
    };
    Vector2.prototype.limit2 = function (limit2) {
        var len2 = this.sqrLen();
        if (len2 > limit2) {
            return this.scale(Math.sqrt(limit2 / len2));
        }
        return this;
    };
    Vector2.prototype.epsilonEquals = function (other, epsilon) {
        if (other == null)
            return false;
        if (Math.abs(other.data[0] - this.data[0]) > epsilon)
            return false;
        if (Math.abs(other.data[1] - this.data[1]) > epsilon)
            return false;
        return true;
    };
    Vector2.prototype.isZero = function () {
        return this.data[0] === 0 && this.data[1] === 0;
    };
    Vector2.prototype.setZero = function () {
        vec2.set(this.data, 0, 0);
        return this;
    };
    return Vector2;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Vector2;
//# sourceMappingURL=Vector2.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/math/Vector2.js
 ** module id = 887
 ** module chunks = 0
 **/